import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=2cf0e6d1&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=2cf0e6d1&prod&lang=scss&scoped=true"
import style1 from "./FAQ.vue?vue&type=style&index=1&id=2cf0e6d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf0e6d1",
  null
  
)

export default component.exports